import { DropdownMenu } from 'radix-ui';

import DropdownItem from './DropdownItem';

import type { DropdownItemProps } from './DropdownItem';

type Props = DropdownItemProps & {
  checked?: boolean;
  forceActive?: boolean;
};

const FilterButtonSingleItem = ({
  count,
  countCategory,
  icon,
  label,
  labelSubtitle,
  onClick,
  showArrow
}: Props) => {
  return (
    <DropdownMenu.Item asChild={true}>
      <DropdownItem
        count={count}
        countCategory={countCategory}
        icon={icon}
        label={label}
        labelSubtitle={labelSubtitle}
        onClick={onClick}
        showArrow={showArrow}
      />
    </DropdownMenu.Item>
  );
};

export default FilterButtonSingleItem;
